import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';
import { APP_ROUTES } from './app/app.routes';
import { provideEnvironment } from './app/providers/environment';
import { provideConstants } from './app/providers/constants/constants.provider';
import { provideTranslateService } from '@ngx-translate/core';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(BrowserModule),
    provideRouter(APP_ROUTES),
    provideAnimations(),
    provideEnvironment({
      dev: {
        frontDomain: 'http://localhost:4200',
        domain: 'http://localhost:4200',
        server: 'http://localhost:3000',
        env: 'development',
        contentfulEndpoint: 'https://graphql.contentful.com/content/v1/spaces/5lisfcir3wum/environments/master',
        contentfulToken: 'udWeSY2kbSwy35bZC5EyciPIDXmF51Gz-yA0poiSHlQ',
        amplitudeKey: '6445e4c8f0fd600a4f0672569726cc68',
      },
      production: {
        frontDomain: 'https://goodchart.co',
        domain: 'https://brands.goodchart.co',
        server: 'https://back.goodchart.co',
        env: 'production',
        contentfulEndpoint: 'https://graphql.contentful.com/content/v1/spaces/5lisfcir3wum/environments/master',
        contentfulToken: 'udWeSY2kbSwy35bZC5EyciPIDXmF51Gz-yA0poiSHlQ',
        amplitudeKey: '9937ec9b9b4327fa400c9cdf2c8af71c',
      },
      staging: {
        frontDomain: 'https://staging.goodchart.co',
        domain: 'https://staging.brands.goodchart.co',
        server: 'https://staging.back.goodchart.co',
        env: 'staging',
        contentfulEndpoint: 'https://graphql.contentful.com/content/v1/spaces/5lisfcir3wum/environments/master',
        contentfulToken: 'udWeSY2kbSwy35bZC5EyciPIDXmF51Gz-yA0poiSHlQ',
        amplitudeKey: '',
      },
    }),
    provideHttpClient(),
    provideConstants(),
    provideTranslateService({
      fallbackLang: 'en',
    }),
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { duration: 2500, horizontalPosition: 'end' },
    },
  ],
};
